import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-label="Bonuses" className="border-y border-grape/10 bg-white/70" data-id="element-16" data-mp="plsj010puu7n">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "22px"
    }} data-id="element-17" data-mp="asz52k13em53">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-18" data-mp="frtl5e7odwli">
          🎁 3 Free Bonuses Included
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm text-plum/60" data-id="element-19" data-mp="5w8pdxt79sk7">
          In addition to the main system, you also get these gifts — at no extra cost.
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-3" data-id="element-20" data-mp="3t0g6egxh6gen">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex h-full flex-col rounded-2xl border border-grape/20 bg-cream p-5" data-id="element-21" data-mp="3t2j4lo8s7fug" data-mpi={i}>
              <img src={b.cover} alt={`${b.title} cover`} width={1024} height={1536} loading="lazy" decoding="async" className="mx-auto h-44 w-auto rounded-lg object-contain drop-shadow-[0_12px_20px_rgba(59,21,32,0.22)] sm:h-52" data-id="element-22" data-mp="3detscov8egpe" />

              <div className="mt-5 flex flex-wrap items-center justify-between gap-2" data-id="element-23" data-mp="2zfkevwyeu0p4">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-lilac-soft px-3 py-1 text-xs font-bold text-grape" data-id="element-24" data-mp="2zhf1rgt8s2vu">
                  <GiftIcon className="h-3.5 w-3.5" data-id="element-25" data-mp="38gs31m77pl5h" /> Bonus {b.n}
                </span>
                <span className="text-sm font-bold" data-id="element-26" data-mp="33hfd2sl1nxyo">
                  <span className="text-plum/40 line-through" data-id="element-27" data-mp="33fuk37edon2x">{b.price}</span>{' '}
                  <span className="text-blush-deep" data-id="element-28" data-mp="noq68w0r3ozq">FREE</span>
                </span>
              </div>

              <h3 className="mt-3 text-base font-bold text-plum" data-id="element-29" data-mp="iqexypq3tmjm">{b.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-plum/65" data-id="element-30" data-mp="3chv39kmwh2k0">{b.desc}</p>
            </motion.div>)}
        </div>

        <div className="mx-auto mt-10 max-w-3xl rounded-2xl border border-blush/25 bg-blush-soft p-6 text-center" style={{
        paddingTop: "11px",
        paddingBottom: "11px"
      }} data-id="element-31" data-mp="3hgg3vl62do8z">
          <p className="text-base font-bold text-plum sm:text-lg" data-id="element-32" data-mp="3qhmni340ff6g">
            💰 Total bonus value: <span className="text-plum/50 line-through" data-id="element-33" data-mp="2tt81bb00stan">$93</span>{' '}
            <span className="text-[15px] text-blush-deep" data-id="element-34" data-mp="2xu0c48ojj691">
              TODAY FREE WITH THE MENORESET SYSTEM™
            </span>
          </p>
        </div>
      </div>
    </section>;
}